import { Typography } from '@mui/material'
import React from 'react'
import { TextStyle } from './TableLabelText.styles'
import { SxProps } from '@mui/system'
import { Theme } from '@mui/material/styles'

interface TableLabelTextProps {
  children: React.ReactNode
  customStyles?: SxProps<Theme>
}

/**
 * TableLabelText
 * @param components
 */
export const TableLabelText: React.FC<TableLabelTextProps> = ({ children, customStyles }) => {
  return (
    <Typography variant="body2" sx={{ ...TextStyle, ...customStyles }}>
      {children}
    </Typography>
  )
}
